import type { ReactNode } from 'react'
import { useLocale } from '../../context/LocaleContext'

export default function AdministrationPage({ title, description, actions, children }: { title: string; description: string; actions?: ReactNode; children: ReactNode }) {
  const { t } = useLocale()
  return <div className="sl-admin-page"><header className="sl-page-heading"><div><p className="sl-eyebrow">{t('Administration SalmaLoad', 'SalmaLoad administration')}</p><h1>{title}</h1><p className="sl-page-description">{description}</p></div>{actions && <div className="sl-page-actions">{actions}</div>}</header><div className="sl-admin-content">{children}</div></div>
}

export function AdministrationTabs<T extends string>({ tabs, value, onChange, panelId, label }: {
  tabs: { id: T; name: string; icon?: ReactNode; disabled?: boolean }[]; value: T; onChange: (value: T) => void; panelId: string; label: string
}) {
  const enabled = tabs.filter(tab => !tab.disabled)
  return <div className="sl-admin-tabs" role="tablist" aria-label={label}>{tabs.map(tab => <button key={tab.id} type="button" role="tab" id={`${panelId}-${tab.id}`} aria-selected={value === tab.id} aria-controls={panelId} tabIndex={value === tab.id ? 0 : -1} disabled={tab.disabled} onClick={() => onChange(tab.id)} onKeyDown={event => {
    let next = enabled.findIndex(item => item.id === tab.id)
    if (event.key === 'ArrowRight') next = (next + 1) % enabled.length
    else if (event.key === 'ArrowLeft') next = (next - 1 + enabled.length) % enabled.length
    else if (event.key === 'Home') next = 0
    else if (event.key === 'End') next = enabled.length - 1
    else return
    event.preventDefault(); onChange(enabled[next].id); document.getElementById(`${panelId}-${enabled[next].id}`)?.focus()
  }}>{tab.icon}<span>{tab.name}</span></button>)}</div>
}
